<template>
  <div class="header-mobile" :key="renderHeaderMobile">
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand class="header-image"></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="text-left">
          <b-nav-item v-if="currentDepartment.rol_name == 'superuser'"
            ><router-link :to="{ name: 'UsersManagement' }"
              ><i class="fa fa-users-cog"></i> Users</router-link
            ></b-nav-item
          >
          <b-nav-item v-if="currentDepartment.rol_name === 'quoter'"
            ><router-link
              :to="{ name: 'Emails', params: { pathName: 'myQueue' } }"
              ><i class="fa fa-house-user fa-lg"></i> My queue</router-link
            ></b-nav-item
          >
          <b-nav-item
            ><router-link
              :to="{ name: 'Emails', params: { pathName: 'queue' } }"
              ><i class="fa fa-list-ul"></i> Queue</router-link
            ></b-nav-item
          >
          <b-nav-item v-if="currentDepartment.department_id == 1"
            ><router-link
              :to="{ name: 'Emails', params: { pathName: 'spanish-queue' } }"
              ><i class="fa fa-list-ul"></i> SP Queue</router-link
            ></b-nav-item
          >
          <b-nav-item
            ><router-link
              :to="{ name: 'Emails', params: { pathName: 'inProcess' } }"
              ><i class="fa fa-spinner"></i> In process</router-link
            ></b-nav-item
          >
          <b-nav-item v-if="currentDepartment.department_id == 1"
            ><router-link
              :to="{ name: 'Emails', params: { pathName: 'hypercubes' } }"
              ><i class="fa fa-cube"></i> Hypercubes</router-link
            ></b-nav-item
          >
          <b-nav-item
            v-if="
              currentDepartment.rol_name == 'superuser' &&
                currentDepartment.department_id == 1
            "
            ><router-link
              :to="{ name: 'Emails', params: { pathName: 'alerts' } }"
              ><i class="fa fa-bell"></i> Alerts</router-link
            ></b-nav-item
          >
          <b-nav-item
            ><router-link
              :to="{ name: 'Emails', params: { pathName: 'failed' } }"
              ><i class="fa fa-times-circle"></i> Failed</router-link
            ></b-nav-item
          >
          <b-nav-item
            ><router-link :to="{ name: 'Emails', params: { pathName: 'sent' } }"
              ><i class="fa fa-paper-plane"></i> Sent</router-link
            ></b-nav-item
          >
          <b-nav-item
            ><router-link
              :to="{ name: 'Emails', params: { pathName: 'unknown' } }"
              ><i class="fa fa-exclamation "></i>Non
              {{ nameDepartment.toUpperCase() }}</router-link
            ></b-nav-item
          >
          <b-nav-item
            ><router-link
              :to="{ name: 'Emails', params: { pathName: 'deleted' } }"
              ><i class="fa fa-trash-alt fa-sm"></i> Deleted</router-link
            ></b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="header-line"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "HeaderMobile",
  data() {
    return {
      currentDepartment: null,
      renderHeaderMobile: 0,
      nameDepartment: null
    };
  },
  computed: {
    ...mapGetters("login", ["showInfoDepartment"]),
    ...mapGetters("quotes", ["showActualQueue"])
  },
  watch: {
    showInfoDepartment(value) {
      this.currentDepartment = value;
      this.renderHeaderMobile += 1;
      this.getNameDepartment();
    },
    showActualQueue() {
      this.getQueueName(this.showActualQueue);
    }
  },
  beforeMount() {
    this.currentDepartment = this.showInfoDepartment;
    this.getNameDepartment();
  },
  methods: {
    getNameDepartment() {
      if (this.currentDepartment.department_id == 2) {
        this.nameDepartment = this.showActualQueue;
      } else {
        this.nameDepartment = this.currentDepartment.department_name;
      }
    },
    getQueueName(name) {
      switch (name) {
        case "ftl":
          this.nameDepartment = "FTL";
          break;
        case "drayage":
          this.nameDepartment = "Drayage";
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bg-info {
  background-color: #17202a !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.header-image {
  content: url("../"+$image-company);
  width: 70px;
  height: auto;
  padding: 0px;
}

a {
  color: #eceff1 !important;
}

.header-line {
  height: 1.5px;
  background-color: #00ff00;
}
</style>
